/* Version: 3.5.149 */
'use client';
import canadianTheme from '../theme/canadianTheme.js';

/**
 * Generates an object with CSS tokens based on the provided theme.
 * @param {object} userTheme - Theme object
 * @returns {object} Object containing CSS token key-value pairs
 */
function cssTokens(userTheme) {
  var _theme$colorPalette, _theme$colorPalette2, _theme$colorPalette3, _theme$colorPalette4, _theme$colorPalette5, _theme$colorPalette6, _theme$colorPalette7, _theme$colorPalette8, _theme$colorPalette9, _theme$colorPalette10, _theme$colorPalette11, _theme$colorPalette12, _theme$colorPalette13, _theme$colorPalette14;
  var theme = userTheme || canadianTheme;
  var tokens = {};

  // Accent color
  if (theme !== null && theme !== undefined && (_theme$colorPalette = theme.colorPalette) !== null && _theme$colorPalette !== undefined && _theme$colorPalette.accentColor) {
    var accentColor = theme.colorPalette.accentColor;
    tokens['--mux-color-accent-default'] = accentColor.shade_default;
    tokens['--mux-color-accent-dark-1'] = accentColor.shade_dark_1;
    tokens['--mux-color-accent-dark-2'] = accentColor.shade_dark_2;
    tokens['--mux-color-accent-dark-3'] = accentColor.shade_dark_3;
    tokens['--mux-color-accent-light-1'] = accentColor.shade_light_1;
    tokens['--mux-color-accent-light-2'] = accentColor.shade_light_2;
    tokens['--mux-color-accent-light-3'] = accentColor.shade_light_3;
    tokens['--mux-color-accent-light-4'] = accentColor.shade_light_4;
  }

  // Primary colors
  if (theme !== null && theme !== undefined && (_theme$colorPalette2 = theme.colorPalette) !== null && _theme$colorPalette2 !== undefined && (_theme$colorPalette2 = _theme$colorPalette2.primaryColors) !== null && _theme$colorPalette2 !== undefined && _theme$colorPalette2.main) {
    var main = theme.colorPalette.primaryColors.main;
    tokens['--mux-color-primary-main-default'] = main.shade_default;
    tokens['--mux-color-primary-main-dark-1'] = main.shade_dark_1;
    tokens['--mux-color-primary-main-dark-2'] = main.shade_dark_2;
    tokens['--mux-color-primary-main-dark-3'] = main.shade_dark_3;
    tokens['--mux-color-primary-main-light-1'] = main.shade_light_1;
    tokens['--mux-color-primary-main-light-2'] = main.shade_light_2;
    tokens['--mux-color-primary-main-light-3'] = main.shade_light_3;
    tokens['--mux-color-primary-main-light-4'] = main.shade_light_4;
    tokens['--mux-color-primary-main-link'] = main.shade_link;
  }
  if (theme !== null && theme !== undefined && (_theme$colorPalette3 = theme.colorPalette) !== null && _theme$colorPalette3 !== undefined && (_theme$colorPalette3 = _theme$colorPalette3.primaryColors) !== null && _theme$colorPalette3 !== undefined && _theme$colorPalette3.alternate) {
    var alternate = theme.colorPalette.primaryColors.alternate;
    tokens['--mux-color-primary-alternate-default'] = alternate.shade_default;
    tokens['--mux-color-primary-alternate-dark-1'] = alternate.shade_dark_1;
    tokens['--mux-color-primary-alternate-dark-2'] = alternate.shade_dark_2;
    tokens['--mux-color-primary-alternate-dark-3'] = alternate.shade_dark_3;
    tokens['--mux-color-primary-alternate-light-1'] = alternate.shade_light_1;
    tokens['--mux-color-primary-alternate-light-2'] = alternate.shade_light_2;
    tokens['--mux-color-primary-alternate-light-3'] = alternate.shade_light_3;
    tokens['--mux-color-primary-alternate-light-4'] = alternate.shade_light_4;
  }

  // Secondary colors
  if (theme !== null && theme !== undefined && (_theme$colorPalette4 = theme.colorPalette) !== null && _theme$colorPalette4 !== undefined && (_theme$colorPalette4 = _theme$colorPalette4.secondaryColors) !== null && _theme$colorPalette4 !== undefined && _theme$colorPalette4.one) {
    var one = theme.colorPalette.secondaryColors.one;
    tokens['--mux-color-secondary-one-default'] = one.shade_default;
    tokens['--mux-color-secondary-one-dark-1'] = one.shade_dark_1;
    tokens['--mux-color-secondary-one-dark-2'] = one.shade_dark_2;
    tokens['--mux-color-secondary-one-dark-3'] = one.shade_dark_3;
    tokens['--mux-color-secondary-one-light-1'] = one.shade_light_1;
    tokens['--mux-color-secondary-one-light-2'] = one.shade_light_2;
    tokens['--mux-color-secondary-one-light-3'] = one.shade_light_3;
    tokens['--mux-color-secondary-one-light-4'] = one.shade_light_4;
  }
  if (theme !== null && theme !== undefined && (_theme$colorPalette5 = theme.colorPalette) !== null && _theme$colorPalette5 !== undefined && (_theme$colorPalette5 = _theme$colorPalette5.secondaryColors) !== null && _theme$colorPalette5 !== undefined && _theme$colorPalette5.two) {
    var two = theme.colorPalette.secondaryColors.two;
    tokens['--mux-color-secondary-two-default'] = two.shade_default;
    tokens['--mux-color-secondary-two-dark-1'] = two.shade_dark_1;
    tokens['--mux-color-secondary-two-dark-2'] = two.shade_dark_2;
    tokens['--mux-color-secondary-two-dark-3'] = two.shade_dark_3;
    tokens['--mux-color-secondary-two-light-1'] = two.shade_light_1;
    tokens['--mux-color-secondary-two-light-2'] = two.shade_light_2;
    tokens['--mux-color-secondary-two-light-3'] = two.shade_light_3;
    tokens['--mux-color-secondary-two-light-4'] = two.shade_light_4;
  }
  if (theme !== null && theme !== undefined && (_theme$colorPalette6 = theme.colorPalette) !== null && _theme$colorPalette6 !== undefined && (_theme$colorPalette6 = _theme$colorPalette6.secondaryColors) !== null && _theme$colorPalette6 !== undefined && _theme$colorPalette6.three) {
    var three = theme.colorPalette.secondaryColors.three;
    tokens['--mux-color-secondary-three-default'] = three.shade_default;
    tokens['--mux-color-secondary-three-dark-1'] = three.shade_dark_1;
    tokens['--mux-color-secondary-three-dark-2'] = three.shade_dark_2;
    tokens['--mux-color-secondary-three-dark-3'] = three.shade_dark_3;
    tokens['--mux-color-secondary-three-light-1'] = three.shade_light_1;
    tokens['--mux-color-secondary-three-light-2'] = three.shade_light_2;
    tokens['--mux-color-secondary-three-light-3'] = three.shade_light_3;
    tokens['--mux-color-secondary-three-light-4'] = three.shade_light_4;
  }

  // Neutral colors
  if (theme !== null && theme !== undefined && (_theme$colorPalette7 = theme.colorPalette) !== null && _theme$colorPalette7 !== undefined && (_theme$colorPalette7 = _theme$colorPalette7.neutralColors) !== null && _theme$colorPalette7 !== undefined && _theme$colorPalette7.dark) {
    var dark = theme.colorPalette.neutralColors.dark;
    tokens['--mux-color-neutral-dark-dark-1'] = dark.shade_dark_1;
    tokens['--mux-color-neutral-dark-default'] = dark.shade_default;
    tokens['--mux-color-neutral-dark-light-1'] = dark.shade_light_1;
    tokens['--mux-color-neutral-dark-light-2'] = dark.shade_light_2;
    tokens['--mux-color-neutral-dark-light-3'] = dark.shade_light_3;
    tokens['--mux-color-neutral-dark-light-4'] = dark.shade_light_4;
  }
  if (theme !== null && theme !== undefined && (_theme$colorPalette8 = theme.colorPalette) !== null && _theme$colorPalette8 !== undefined && (_theme$colorPalette8 = _theme$colorPalette8.neutralColors) !== null && _theme$colorPalette8 !== undefined && _theme$colorPalette8.light) {
    var light = theme.colorPalette.neutralColors.light;
    tokens['--mux-color-neutral-light-white'] = light.shade_white;
    tokens['--mux-color-neutral-light-default'] = light.shade_default;
    tokens['--mux-color-neutral-light-light-1'] = light.shade_light_1;
    tokens['--mux-color-neutral-light-light-2'] = light.shade_light_2;
    tokens['--mux-color-neutral-light-dark-1'] = light.shade_dark_1;
    tokens['--mux-color-neutral-light-dark-2'] = light.shade_dark_2;
    tokens['--mux-color-neutral-light-dark-3'] = light.shade_dark_3;
  }

  // Utility colors
  if (theme !== null && theme !== undefined && (_theme$colorPalette9 = theme.colorPalette) !== null && _theme$colorPalette9 !== undefined && (_theme$colorPalette9 = _theme$colorPalette9.utilityColors) !== null && _theme$colorPalette9 !== undefined && _theme$colorPalette9.error) {
    tokens['--mux-color-utility-error'] = theme.colorPalette.utilityColors.error;
  }
  if (theme !== null && theme !== undefined && (_theme$colorPalette10 = theme.colorPalette) !== null && _theme$colorPalette10 !== undefined && (_theme$colorPalette10 = _theme$colorPalette10.utilityColors) !== null && _theme$colorPalette10 !== undefined && _theme$colorPalette10.alert) {
    tokens['--mux-color-utility-alert'] = theme.colorPalette.utilityColors.alert;
  }
  if (theme !== null && theme !== undefined && (_theme$colorPalette11 = theme.colorPalette) !== null && _theme$colorPalette11 !== undefined && (_theme$colorPalette11 = _theme$colorPalette11.utilityColors) !== null && _theme$colorPalette11 !== undefined && _theme$colorPalette11.warning) {
    tokens['--mux-color-utility-warning'] = theme.colorPalette.utilityColors.warning;
  }
  if (theme !== null && theme !== undefined && (_theme$colorPalette12 = theme.colorPalette) !== null && _theme$colorPalette12 !== undefined && (_theme$colorPalette12 = _theme$colorPalette12.utilityColors) !== null && _theme$colorPalette12 !== undefined && _theme$colorPalette12.info) {
    tokens['--mux-color-utility-info'] = theme.colorPalette.utilityColors.info;
  }
  if (theme !== null && theme !== undefined && (_theme$colorPalette13 = theme.colorPalette) !== null && _theme$colorPalette13 !== undefined && (_theme$colorPalette13 = _theme$colorPalette13.utilityColors) !== null && _theme$colorPalette13 !== undefined && _theme$colorPalette13.complete) {
    tokens['--mux-color-utility-complete'] = theme.colorPalette.utilityColors.complete;
  }
  if (theme !== null && theme !== undefined && (_theme$colorPalette14 = theme.colorPalette) !== null && _theme$colorPalette14 !== undefined && (_theme$colorPalette14 = _theme$colorPalette14.utilityColors) !== null && _theme$colorPalette14 !== undefined && _theme$colorPalette14.link) {
    tokens['--mux-color-utility-link'] = theme.colorPalette.utilityColors.link;
  }
  return tokens;
}

export { cssTokens as default };
